import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { PLAYGROUND_USERS } from '../../../../playground/types/common';
import { AuthService } from '../services/auth.service';

export function UserPlaygroundAuthGuard(): CanActivateFn {
    return () => {
        const playgroundUsers: string[] = PLAYGROUND_USERS;
        const router = inject(Router);
        const authService = inject(AuthService);

        const currentLoggedUser = authService.getLoggedInUser() || null;
        if (!currentLoggedUser) {
            return of(false);
        }
        if (!playgroundUsers.includes(currentLoggedUser?.NIF)) {
            console.error('You are not allowed to see this page');
            router.navigate(['/notaccesible']);
            return of(false);
        }
        return of(true);
    };
}
